module.exports = __webpack_public_path__ + "static/img/beijing1.3a51a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/beijing1.png
// module id = HGze
// module chunks = 1